import React, { Component } from "react";
import { Modal, Form, Row, Col, Button } from "antd";
import InputForm from "./InputForm";
import "./Form.css";

const { Item: ItemForm } = Form;

export default class MedidaForm extends Component {
  state = {
    registro: {
      med_idf: '',
      med_descricao: '',
    }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado.data,
        visualizar: this.props.registroSelecionado.visualizar,
      }, () => {
        this.refs.med_descricao.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onOK = () => {
    if ((!this.state.registro.med_descricao) || (this.state.registro.med_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }
    this.props.onSalvarClick(this.state.registro);
  };

  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { med_idf, med_descricao } = this.state.registro;

    return (
      <Modal
        title={med_idf ? "Edição de Unid. Medida" : "Cadastro de Unid. Medida"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={24}>
              <span>Descrição *</span>
              <InputForm
                id="med_descricao"
                ref="med_descricao"
                maxLength={20}
                onChange={this.onChange}
                value={med_descricao}
                validator={value => Boolean(value)}
              />
            </Col>
          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizar ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Salvar
                  </Button>
                )}

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MedidaForm.js